import { createListenerMiddleware } from "@reduxjs/toolkit";
import { userLoggedInListener } from "Data/Redux/Middleware/Listeners/User";
import { appRehydratedListener } from "Data/Redux/Middleware/Listeners/System";
import type { AppState } from "Data/Redux/Reducers";

const listenerMiddleware = createListenerMiddleware<AppState>();

[ userLoggedInListener, appRehydratedListener ].forEach(listener => {
	listener(listenerMiddleware);
});

export default listenerMiddleware;
